import { sectionTitleSlide } from '../../../../slides/shared/section-title-slide';

export const salesAttributionTitleSlide =
  sectionTitleSlide('Sales Attribution');
